import React from "react";

export const Overview = () => {
  return (
    <div className="flex items-center justify-between p-4 bg-gray-100 font-MTNfont">
      <div>
        <h1 className="font-sans text-xl font-bold">Request</h1>
      </div>
    </div>
  );
};
